import React from "react";
import "./Meet_Section.css";

const Meet_Section = () => {
  return (
    <section className="Meet_Section">
      <div className="container">
        <div className="row align-items-center">
          <div class="col-lg-5">
            <div class="content-box">             
              <h2>
                <span >TAKE ALONG</span>
                Something for
                <span>Every Moment</span>
              </h2>

              <p className="descn">
                Whether it's a quick hunger break, a sweet craving after meals,
                a lunchbox companion for kids, an on-the-go travel snack, or a
                refreshing sharbat on a hot summer day.
              </p>

              <p className="descn">
                Nutripair brings together traditional taste, authentic flavors,
                hygienic packaging, and everyday affordability in products made
                for daily life.
              </p>

              <div class="moment-list">
                <p className="inner_text">Traveling?</p>
                <p className="inner_text">Lunchbox confusion?</p>
                <p className="inner_text">Sudden cravings?</p>
                <p className="inner_text">Need refreshment?</p>
              </div>

              <h3 class="tagline">
                Har Din Ki
                <span>Traditional Treat</span>
              </h3>
            </div>
          </div>
          <div className="col-lg-7">
            <div className="img_holder">
              <img
                src={
                  process.env.PUBLIC_URL + "/assets/images/home/about/meet2.png"
                }
                className="right_img"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Meet_Section;
